import * as application from '../../actions/application-detail.actions';
import * as applicationDelete from '../../actions/application-delete.actions';

type Actions = application.Actions
    | applicationDelete.Actions;

/**
 * Reducer that adds / removes application id from expanded list.
 *
 * When application is expanded its id is added into list of expanded applications.
 * As a side effect application detail has to be loaded.
 */
export const expandedApplicationList = (state: string[] = [], action: Actions) => {
    switch (action.type) {
        case application.TOGGLE_DETAIL:
            if (state.indexOf(action.payload.appId) > -1) {
                return remove(state, action.payload.appId);
            } else {
                return [...state, action.payload.appId];
            }
        case applicationDelete.DELETE_SUCCESS:
            return remove(state, action.payload);
        case application.REMOVE_DETAIL:
            return remove(state, action.payload.appId);
        default:
            return state;
    }
};

function remove(state: string[], removeAppId: string) {
    return state.filter(appId => appId !== removeAppId);
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/expanded-application/expanded-application-list.reducer.ts